import { useEffect, type ReactNode } from 'react'
import { mountAuthBridge } from './service'

export function AuthLifecycle({ children }: { children: ReactNode }) {
  useEffect(mountAuthBridge, [])
  return children
}
